import React from 'react';
import AwarnessCampaign2023 from 'views/AwarnessCampaign2023';

const AccountGeneralPage = () => {
  return <AwarnessCampaign2023 />;
};

export default AccountGeneralPage;
